<template>
  <section class="pcm-b-wrapper" aria-label="黄果短剧客户端下载">
    <div class="pcm-b-stage">
      <img
        v-for="layer in sceneLayers"
        :key="layer.name"
        :class="['pcm-b-layer', 'pcm-b-' + layer.name]"
        :src="layer.src"
        :style="layerStyle(layer)"
        :alt="layer.alt || ''"
        draggable="false"
      />

      <img
        class="pcm-b-layer pcm-b-character"
        :src="characterImg"
        alt=""
        draggable="false"
      />
      <img
        class="pcm-b-layer pcm-b-bottom"
        :src="bottomImg"
        alt=""
        draggable="false"
      />

      <div class="pcm-b-copy">
        <img
          v-for="layer in copyLayers"
          :key="layer.name"
          :class="['pcm-b-layer', 'pcm-b-' + layer.name]"
          :src="layer.src"
          :style="layerStyle(layer)"
          :alt="layer.alt || ''"
          draggable="false"
        />
        <button
          type="button"
          class="pcm-b-qr"
          aria-label="放大手机扫码下载二维码"
          aria-haspopup="dialog"
          @click="openQr($event)"
        >
          <img v-if="qrImg" :src="qrImg" alt="手机扫码下载二维码" />
          <span v-else class="pcm-b-qr-loading" role="status"
            >二维码生成中</span
          >
        </button>
        <button
          type="button"
          class="pcm-b-download"
          aria-label="扫码下载 APP"
          aria-haspopup="dialog"
          @click="openQr($event)"
        >
          <img :src="downloadImg" alt="" draggable="false" />
        </button>
        <p class="pcm-b-download-hint">下载免费预览更多短剧</p>
        <p class="pcm-b-description">
          不同主题，不同惊喜，每次打开都有新的故事发生。
        </p>
        <site-links class="pcm-b-addresses" variant="pc" :version="version" />
      </div>
      <div class="pcm-b-light">
        <img
          class="pcm-b-layer pcm-b-foreground"
          :src="foregroundImg"
          :style="layerStyle(foreground)"
          alt=""
          draggable="false"
        />
      </div>
    </div>

    <transition name="pcm-b-fade">
      <div v-if="qrVisible" class="pcm-b-qr-mask" @click.self.stop="closeQr">
        <div
          class="pcm-b-qr-card"
          role="dialog"
          aria-modal="true"
          aria-labelledby="pcm-b-qr-title"
          aria-describedby="pcm-b-qr-description"
          @click.stop
        >
          <button
            ref="qrClose"
            type="button"
            class="pcm-b-qr-close"
            aria-label="关闭二维码"
            @click="closeQr"
          >
            ×
          </button>
          <h2 id="pcm-b-qr-title" class="pcm-b-qr-title">手机扫码下载</h2>
          <div class="pcm-b-qr-large">
            <img v-if="qrImg" :src="qrImg" alt="手机扫码下载二维码" />
            <span v-else role="status">二维码生成中</span>
          </div>
          <p id="pcm-b-qr-description" class="pcm-b-qr-description">
            支持 iOS 与 Android
          </p>
          <button
            ref="qrConfirm"
            type="button"
            class="pcm-b-qr-confirm"
            @click="closeQr"
          >
            我知道了
          </button>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import backdropImg from "@/assets/images/landingB/pc-backdrop.webp";
import backgroundImg from "@/assets/images/landingB/pc-background.webp";
import filmImg from "@/assets/images/landingB/pc-film.webp";
import scriptImg from "@/assets/images/landingB/pc-script.webp";
import logoImg from "@/assets/images/landingB/pc-logo.webp";
import characterImg from "@/assets/images/landingB/pc-character.webp";
import bottomImg from "@/assets/images/landingB/pc-bottom.webp";
import subtitleImg from "@/assets/images/landingB/pc-subtitle.webp";
import categoriesImg from "@/assets/images/landingB/pc-categories.webp";
import titleImg from "@/assets/images/landingB/pc-title.webp";
import downloadImg from "@/assets/images/landingB/pc-download.webp";
import foregroundImg from "@/assets/images/landingB/pc-foreground.webp";
import { landingPageClick } from "@/utils/eventTracker";
import siteLinks from "./siteLinks";

const DESIGN_WIDTH = 1920;
const DESIGN_HEIGHT = 1080;

export default {
  components: { siteLinks },
  props: {
    qrImg: { type: String, default: "" },
    os: { type: [Object, String], default: () => ({}) },
    configs: { type: [Array, Object], default: () => [] },
    version: { type: String, default: "B" }
  },
  data() {
    return {
      downloadImg,
      foregroundImg,
      characterImg,
      bottomImg,
      qrVisible: false,
      // Coordinates follow the individual Figma layers on the 1920 × 1080 frame.
      sceneLayers: [
        {
          name: "backdrop",
          src: backdropImg,
          x: 0,
          y: 0,
          width: 1920,
          height: 1080
        },
        {
          name: "background",
          src: backgroundImg,
          x: 0,
          y: -1,
          width: 1920,
          height: 1081
        },
        { name: "film", src: filmImg, x: 0, y: -1, width: 1920, height: 1081 },
        {
          name: "script",
          src: scriptImg,
          x: 1431,
          y: -1,
          width: 353,
          height: 113
        },
        {
          name: "logo",
          src: logoImg,
          x: 80,
          y: 56,
          width: 370.467346,
          height: 92.311035,
          alt: "黄果短剧 huangguo.com"
        }
      ],
      copyLayers: [
        {
          name: "subtitle",
          src: subtitleImg,
          x: -67.99501,
          y: 260.627121,
          width: 1100.5784,
          height: 819.743683
        },
        {
          name: "categories",
          src: categoriesImg,
          x: -49,
          y: 718,
          width: 1074,
          height: 107,
          alt: "都市情感、悬疑反转、古装传奇"
        },
        {
          name: "title",
          src: titleImg,
          x: 2,
          y: 149,
          width: 1104.342041,
          height: 568.838318
        }
      ],
      foreground: {
        x: 1045.999817,
        y: -287,
        width: 1264.891604,
        height: 1378.480654
      }
    };
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    layerStyle(layer) {
      return {
        left: (layer.x / DESIGN_WIDTH) * 100 + "%",
        top: (layer.y / DESIGN_HEIGHT) * 100 + "%",
        width: (layer.width / DESIGN_WIDTH) * 100 + "%",
        height: (layer.height / DESIGN_HEIGHT) * 100 + "%"
      };
    },
    openQr(event) {
      this.qrTrigger = event.currentTarget;
      this.qrVisible = true;
      landingPageClick(this, {
        tab_key: "pc_qr_download",
        tab_name: "扫码下载APP",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
      this.$nextTick(() => {
        this.$refs.qrClose.focus();
      });
    },
    closeQr() {
      this.qrVisible = false;
      if (this.qrTrigger) this.qrTrigger.focus();
    },
    onKeydown(event) {
      if (!this.qrVisible) return;
      if (event.key === "Escape") {
        this.closeQr();
      } else if (event.key === "Tab") {
        const first = this.$refs.qrClose;
        const last = this.$refs.qrConfirm;
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }
};
</script>

<style scoped>
.pcm-b-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #0b0101 url("~@/assets/images/landingB/pc-backdrop.webp") center /
    cover no-repeat;
  color: #f2f2f4;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.pcm-b-wrapper * {
  font-family: inherit;
}

.pcm-b-backdrop,
.pcm-b-background,
.pcm-b-film {
  object-fit: cover;
}

.pcm-b-logo,
.pcm-b-script {
  object-fit: contain;
  object-position: left center;
}

.pcm-b-character {
  right: 0;
  bottom: 0;
  width: min(83.333333vw, 131.208997vh);
  height: auto;
  /* Match the design's 229px overflow on the 1600px-wide character layer. */
  transform: translateX(14.3125%);
  -webkit-mask-image: linear-gradient(to right, transparent, #000 4%);
  mask-image: linear-gradient(to right, transparent, #000 4%);
}

.pcm-b-bottom {
  right: 0;
  bottom: 0;
  width: 100%;
  height: auto;
}

/* Keep the original spacing inside one uniformly scaled, bottom-aligned frame. */
.pcm-b-copy,
.pcm-b-light {
  position: absolute;
  width: min(100vw, 177.777778vh);
  height: min(56.25vw, 100vh);
  pointer-events: none;
}

.pcm-b-copy {
  left: 50px;
  bottom: 0;
}

.pcm-b-copy button {
  pointer-events: auto;
}

.pcm-b-light {
  top: 0;
  right: 0;
}

.pcm-b-wrapper button {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
  appearance: none;
}

.pcm-b-wrapper button:focus-visible {
  outline: 3px solid #ffd378;
  outline-offset: 4px;
}

.pcm-b-stage {
  position: relative;
  flex-shrink: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  isolation: isolate;
}

.pcm-b-layer {
  position: absolute;
  display: block;
  max-width: none;
  pointer-events: none;
  user-select: none;
}

.pcm-b-qr {
  position: absolute;
  left: 3.802083%;
  top: 77.673069%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10.15625%;
  height: 18.055556%;
  border-radius: min(0.520833vw, 0.925926vh);
  background: #fff;
}

.pcm-b-qr img {
  display: block;
  width: 87.179487%;
  height: 87.179487%;
}

.pcm-b-qr-loading {
  color: #6b6b74;
  font-size: min(0.729167vw, 1.296296vh);
}

.pcm-b-download {
  position: absolute;
  left: 15.729167%;
  top: 77.348995%;
  width: 15.208333%;
  height: 7.222222%;
  background: transparent;
  transition: filter 150ms ease;
}

.pcm-b-download:hover {
  filter: brightness(1.1);
}

.pcm-b-download:active {
  filter: brightness(0.9);
}

.pcm-b-download img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left center;
}

.pcm-b-download-hint,
.pcm-b-description {
  position: absolute;
  margin: 0;
  color: #f5e69d;
  font-size: min(1.770833vw, 3.148148vh);
  font-weight: 400;
  line-height: 0.999156;
  white-space: nowrap;
}

.pcm-b-download-hint {
  left: 31.458333%;
  top: 79.386032%;
  width: 17.708333%;
  text-align: center;
}

.pcm-b-description {
  left: 15.729167%;
  top: 85.311957%;
  width: 40.729167%;
}

.pcm-b-addresses {
  position: absolute;
  left: 15.729167%;
  top: 89.941587%;
  width: 44.270833%;
  height: calc(6.111111% - 2px);
}

.pcm-b-foreground {
  z-index: 1;
}

.pcm-b-qr-mask {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(11, 1, 1, 0.8);
}

.pcm-b-qr-card {
  position: relative;
  box-sizing: border-box;
  width: 340px;
  max-width: 100%;
  padding: 32px 28px 24px;
  border: 1px solid rgba(255, 211, 120, 0.35);
  border-radius: 20px;
  background: #20130d;
  text-align: center;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.4);
}

.pcm-b-qr-title {
  margin: 0 0 20px;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
}

.pcm-b-qr-large {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 220px;
  margin: 0 auto;
  border-radius: 12px;
  background: #fff;
  color: #6b6b74;
  font-size: 14px;
}

.pcm-b-qr-large img {
  display: block;
  width: 200px;
  height: 200px;
}

.pcm-b-qr-description {
  margin: 16px 0 20px;
  color: #d3bda8;
  font-size: 14px;
  line-height: 20px;
}

.pcm-b-qr-card .pcm-b-qr-close {
  position: absolute;
  top: 7px;
  right: 9px;
  width: 32px;
  height: 32px;
  background: transparent;
  color: #d3bda8;
  font-size: 28px;
  line-height: 32px;
}

.pcm-b-qr-card .pcm-b-qr-confirm {
  width: 100%;
  height: 44px;
  border-radius: 24px;
  background: linear-gradient(180deg, #ffd26e, #ff9b08);
  color: #2d1705;
  font-size: 16px;
  font-weight: 600;
}

.pcm-b-fade-enter-active,
.pcm-b-fade-leave-active {
  transition: opacity 180ms ease;
}

.pcm-b-fade-enter,
.pcm-b-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .pcm-b-download,
  .pcm-b-fade-enter-active,
  .pcm-b-fade-leave-active {
    transition: none;
  }
}
</style>
